import { MultiDayAppointmentRow } from '../types/agenda.types';
import MultiDayListTable from './MultiDayListTable';

interface MonthListViewProps {
  rows: MultiDayAppointmentRow[];
  loading: boolean;
}

/** Lista del mes (lente Mes · Lista). */
export default function MonthListView({ rows, loading }: MonthListViewProps) {
  return <MultiDayListTable rows={rows} loading={loading} />;
}
